import EventEmitter from "events";
import { Room } from "../models/Room";
import { RoomSetting, User, UserSimplified } from "../models/User";
import { UserBlock } from "../models/UserBlock";
import { Fire } from "./FireClient";
import { LocalStorage } from "./Utils/LocalStorage";
import { Workspace } from "../models/Workspace";

export class My {
  static RoomEmitter = new EventEmitter();
  static RoomSettingEmitter = new EventEmitter();

  static get user(): User {
    return Fire.auth.appUser ?? User.empty();
  }

  static UserBlocks = new Map<string, UserBlock>();
  static DeletedMessages = new Map<string, boolean>();
  static Rooms = new Map<string, Room>(); // room.id, room
  static RoomSettings = new Map<string, RoomSetting>(); // room.id, room setting
  // static Workspaces: Workspace[] = [];

  private constructor() {
  }

  static isLoggedIn() {
    // console.log('My.isLoggedIn: ', !!this.user.id);
    return Boolean(this.user.id);
  }

  static async logoutUser() {
    // this.user = User.empty();
    await Fire.auth.logoutUser();
    LocalStorage.clear();
  }

  static setRooms(_rooms: Room[]) {
    My.Rooms.clear();
    _rooms.forEach(r => {
      My.Rooms.set(r.id, r);
    });
    My.RoomEmitter.emit("Update");
  }

  static updateRoomSettings() {
    if (this.user.roomSettings) {
      this.user.roomSettings.forEach(rs => this.RoomSettings.set(rs.roomId, rs));
    }
  }

  static subscribeToRoomUpdates(handler: () => void): () => void {
    My.RoomEmitter.on("Update", handler);
    return () => My.RoomEmitter.removeListener("Update", handler);
  }

  static subscribeToRoomSettingUpdates(handler: () => void): () => void {
    My.RoomSettingEmitter.on("Update", handler);
    return () => My.RoomSettingEmitter.removeListener("Update", handler);
  }

  // static getRoomSetting(roomId: string): RoomSetting | null {
  //   return this.user?.roomSettings?.find(s => s.roomId === roomId) ?? null;
  // }

  static saveRoomNotificationSetting(roomId: string, settings: RoomSetting) {
    if (!this.user.roomSettings) {
      this.user.roomSettings = [];
    }
    if (!this.user.roomSettings.find(s => s.roomId === roomId)) {
      this.user.roomSettings.push(new RoomSetting(roomId));
    }
    const index = this.user.roomSettings.findIndex(s => s.roomId === roomId);
    this.user.roomSettings[index] = settings;
    Fire.updateUserRoomNotificationSetting(this.user);
    this.updateRoomSettings();
    My.RoomSettingEmitter.emit("Update");
  }

  static getUserFromRooms(userId: string): User | null {
    const rooms = Array.from(My.Rooms.values());

    for (const room of rooms) {
      const user = room.users.find(u => u.id === userId);
      if (user) {
        return user;
      }
    }
    return null;
  }

  static async getOrFetchWorkspace(wsId: string | undefined | null, workspaces: Workspace[]): Promise<Workspace | undefined> {
    if (wsId) {
      const ws = workspaces.find(w => w.id == wsId);
      if (ws) {
        return ws as Workspace;
      } else {
        return await Fire.ws.getWorkspace(wsId);
      }
    }
    return undefined;
  }

  static getUsersFromAllRooms(): UserSimplified[] {
    let membersMap = new Map<string, UserSimplified>();
    My.Rooms.forEach(r => {
      r.users.forEach(m => {
        membersMap.set(m.id, { id: m.id, name: m.name, email: m.email, photoUrl: m.photoUrl });
      });
    });
    return Array.from(membersMap.values());
  }
}
